// extracted by mini-css-extract-plugin
module.exports = {"root":"Addtocart_root__u_cK3","input":"Addtocart_input__2ThEY","add_to_cart_button":"Addtocart_add_to_cart_button__2fRaP","disabled":"Addtocart_disabled__3pLCS"};